import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/terms-conditions/HeroBanner";
import TermCondition from "../components/terms-conditions/TermCondition";


export default function TermsConditions() {
    return (
        <>
            <Header />

            <HeroBanner />

            <TermCondition />

            <Footer />
        </>
    );
}